import type { User } from '@supabase/supabase-js';

// Controls who sees the Admin link/page in the UI. This is cosmetic only —
// the real check happens server-side in the check-users / delete-user edge
// functions, which keep their own copy of this list.
const ADMIN_EMAILS = ['alsoto007@gmail.com'];

export function isAdmin(user: User | null): boolean {
  return !!user?.email && !!user.email_confirmed_at && ADMIN_EMAILS.includes(user.email.toLowerCase());
}
